import { LANDING_AMPLITUDE_EVENTS, LOCAL_STORAGE_KEYS } from '@/constants';
import benefit from '@/public/images/blur-text-in-image/benefits.webp';
import hero from '@/public/images/blur-text-in-image/hero.webp';
import howWork from '@/public/images/blur-text-in-image/howItWorks.webp';
import whyLift from '@/public/images/blur-text-in-image/whyLift.webp';
import { type LandingConfigItem } from '../../types';
import { exploreConfig } from './exploreConfig';
import { tryLiftConfig } from './tryLiftConfig';

export const landingBlurTextInImageConfig: LandingConfigItem = {
	id: 'blur-text-in-image',
	translationLocale: 'blur-text-in-image',
	withDropZone: false,
	hero: {
		type: 'noDropzone',
		title: 'heroData_title',
		description: 'heroData_subtitle',
		buttonText: 'heroData_buttonText',
		background: true,
		images: [
			{
				image: hero,
				title: 'heroData_heroTitle',
				alt: 'heroData_heroAlt',
			},
		],
	},
	howItWork: {
		title: 'howItWorkData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '🖼',
				title: 'howItWorkData_title1',
				subtitle: 'howItWorkData_subtitle1',
			},
			{
				icon: '🎯',
				title: 'howItWorkData_title2',
				subtitle: 'howItWorkData_subtitle2',
			},
			{
				icon: '✨',
				title: 'howItWorkData_title3',
				subtitle: 'howItWorkData_subtitle3',
			},
			{
				icon: '🤘',
				title: 'howItWorkData_title4',
				subtitle: 'howItWorkData_subtitle4',
			},
		],
		images: [
			{
				image: howWork,
				title: 'howItWorkData_imageTitle',
				alt: 'howItWorkData_imageAlt',
			},
		],
	},
	benefits: {
		title: 'benefitData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle1',
			},
			{
				icon: '🔹',
				title: '',
				subtitle: 'benefitData_subtitle2',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle3',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle4',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle5',
			},
		],
		images: [
			{
				image: benefit,
				title: 'benefitData_imageTitle',
				alt: 'benefitData_imageAlt',
			},
		],
	},
	faq: {
		title: 'faqData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				title: 'faqData_title1',
				subtitle: 'faqData_subtitle1',
			},
			{
				title: 'faqData_title2',
				subtitle: 'faqData_subtitle2',
			},
			{
				title: 'faqData_title3',
				subtitle: 'faqData_subtitle3',
			},
			{
				title: 'faqData_title4',
				subtitle: 'faqData_subtitle4',
			},
		],
	},
	whyLift: {
		title: 'whyUseData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '✅',
				title: 'whyUseData_title1',
				subtitle: 'whyUseData_subtitle1',
			},
			{
				icon: '✅',
				title: 'whyUseData_title2',
				subtitle: 'whyUseData_subtitle2',
			},
			{
				icon: '✅',
				title: 'whyUseData_title3',
				subtitle: 'whyUseData_subtitle3',
			},
			{
				icon: '✅',
				title: 'whyUseData_title4',
				subtitle: 'whyUseData_subtitle4',
			},
		],
		images: [
			{
				image: whyLift,
				title: 'whyUseData_imageTitle',
				alt: 'whyUseData_imageAlt',
			},
		],
	},
	explore: {
		...exploreConfig,
	},
	tryLift: {
		...tryLiftConfig,
	},
	analytics: {
		scrolledPercentName: LOCAL_STORAGE_KEYS.BLUR_TEXT_IN_IMAGE_SCROLLED_POINTS,
		eventPropertyType: LANDING_AMPLITUDE_EVENTS.BLUR_TEXT_IN_IMAGE,
		galleryContext: LANDING_AMPLITUDE_EVENTS.BLUR_TEXT_IN_IMAGE_LANDING,
	},
};
